import { useGetPublicCertificateByIdQuery } from '@certificate/graphql';
import { useEffect } from 'react';

import { CertificateNavigatorError, CertificateNavigatorLoading } from '../../components';

interface CertificateNavigatorProps {
  certificateId: string;
}

export default function CertificateNavigator(props: Readonly<CertificateNavigatorProps>) {
  const { certificateId } = props;
  //REMARK: Uncomment when search params are needed
  // const [searchParams] = useSearchParams();
  // const source = searchParams.get('source');

  const {
    data,
    error,
    loading: isLoading,
  } = useGetPublicCertificateByIdQuery({
    variables: { input: { id: certificateId } },
  });

  useEffect(() => {
    const url = data?.certGetPublicCertificateById?.publicCertificateUrl;
    if (url) {
      window.location.href = url;
    }
  }, [data]);

  if (isLoading) {
    return <CertificateNavigatorLoading />;
  }

  if (error || !data?.certGetPublicCertificateById?.publicCertificateUrl) {
    return <CertificateNavigatorError />;
  }

  return null;
}
